import {Component, OnDestroy, OnInit} from '@angular/core';
import {RmOrderService} from '../../services/rm-order.service';
import {Order} from '../../classes/order';
import {RepublicaMovilService} from '../../services/republica-movil.service';
import {FormBuilder, Validators} from '@angular/forms';
import {RmConfirmationService} from "../../services/rm-confirmation.service";
import { superStatus } from 'src/app/shared/constantes';
import { Subscription } from 'rxjs';
import { RmGlobals } from '../../classes/rm-globals';

@Component({
    selector: 'app-rm-finished',
    templateUrl: './rm-finished.component.html',
    styleUrls: ['./rm-finished.component.css', '../../../../assets/css/rm-theme.css'],
    standalone: false
})
export class RmFinishedComponent implements OnInit, OnDestroy {
    public contractId = '-';
    public order: Order;
    public typeOrder: string;
    public rateFtth: any = null;
    public ratesMobiles = [];
    public totalPrice = 0;
    public form: any;
    public isLoading = false;
    public downloaded = {
        sepa: false,
        sepa_error: false,
        contract: false,
        contract_error: false
    }
    public orderInfo: any;
    public dropzoneElemIds = ['dropZone', 'dropZoneLink', 'dropZoneImg'];
    public date = null;
    public uploadingFile = false;
    public typeMobile: any = {
        altas: [],
        portas: []
    };
    public showErrorUploadFile: boolean = false;
    public superStatus: any = superStatus;
    private allSubscription: Subscription[] = [];

    constructor(
        private rmService: RepublicaMovilService,
        private orderService: RmOrderService,
        private confirmationService: RmConfirmationService,
        private formBuilder: FormBuilder,
        private rmGlobals: RmGlobals
    ) { }

    ngOnInit(): void {
        this.getDate();

        this.form = this.formBuilder.group({
            check1: ['', Validators.required],
            check2: ['', Validators.required],
        });

        this.allSubscription.push(this.rmService.getTypeOrder()
            .subscribe((data: any) => {
                this.typeOrder = data;
            })
        );

        this.allSubscription.push(this.rmService.getRateFtth()
            .subscribe((data: any) => {
                this.rateFtth = data;
                this.totalPrice = this.rmGlobals.updateTotalPrice(this.rateFtth, this.ratesMobiles);
            })
        );

        this.allSubscription.push(this.rmService.getRatesMobile()
            .subscribe((data: any) => {
                if (data != null) {
                    this.ratesMobiles = data;
                    this.totalPrice = this.rmGlobals.updateTotalPrice(this.rateFtth, this.ratesMobiles);
                }
            })
        );

        this.allSubscription.push(this.orderService.getOrder()
            .subscribe((data: any) => {
                this.order = data;
                if (this.order && this.order.order_id) {
                    if (this.order.mobiles && this.order.mobiles.length) {                    
                        this.typeMobile.portas = this.order.mobiles.filter(mobile => mobile.msisdn !== '');
                        this.typeMobile.altas = this.order.mobiles.filter(mobile => mobile.msisdn === '');
                    }
                    this.getOrderInfo(this.order.order_id);
                }            
            })
        );

        this.allSubscription.push(this.confirmationService.getFinished()
            .subscribe((data: boolean) => {
                if (this.order && this.order.order_id) {
                    this.getOrderInfo(this.order.order_id);
                }
            })
        );
    }

    getOrderInfo(orderId) {
        this.orderService.getOrderFromService(orderId)
            .subscribe((orderInfo: any) => {
                if (orderInfo && orderInfo.msg) {
                    this.orderInfo = orderInfo.msg;
                }
                if (orderInfo && orderInfo.msg && orderInfo.msg.tracking_id) {
                    this.contractId = orderInfo.msg.tracking_id.toUpperCase();
                }
            });
    }

    getDate() {
        this.date = new Date();
    }

    priceWithIVA(price: number): number {
        return price * 1.21;
    }

    public errorHandling = (control: string, error: string) => {
        if (this.form.get(control).invalid && (this.form.get(control).dirty || this.form.get(control).touched)) {
            return this.form.controls[control].hasError(error);
        }
    }

    descargar(type, file?) {
        if (this.order) {
            if (type === 'sepa') {
                this.downloaded.sepa = true;
                this.downloaded.sepa_error = false;
                this.rmService.getSepa(this.order.order_id)
                    .subscribe(data => {
                        if (data) {
                            this.downloaded.sepa = false;
                            this.downlandFile(data, 'Sepa_' + this.order.order_id + '.pdf');
                        }
                    }, (error) => {
                        this.downloaded.sepa = false;
                        this.downloaded.sepa_error = true;
                    });
            }
            if (type === 'contrato') {
                this.downloaded.contract = true;
                this.downloaded.contract_error = false;
                this.rmService.getContract(this.order.order_id)
                    .subscribe(data => {
                        if (data) {
                            this.downloaded.contract = false;
                            this.downlandFile(data, 'Contrato_' + this.order.order_id + '.pdf');
                        }
                    }, (error) => {
                        this.downloaded.contract = false;
                        this.downloaded.contract_error = true;
                    });
            }            
            if (type === 'other') {
                file.downloaded = true;
                this.rmService.getFileUpload(this.order.order_id, file.asset_id)
                    .subscribe(data => {
                        if (data) {
                            file.downloaded = false;
                            this.downlandFile(data, file.file_name);
                        }
                    });
            }
        }
    }

    downlandFile(file, name) {
        const url = window.URL.createObjectURL(file);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
    }

    allDownloaded() {
        let allDownloaded = true;
        Object.values(this.downloaded).forEach(value => {
            if (!value) {
                allDownloaded = false;
            }
        });
        return allDownloaded;
    }

    uploadFile(file) {
        this.uploadingFile = true;
        this.showErrorUploadFile = false;
        this.rmService.uploadFile(file, this.order.order_id)
            .subscribe((data: any) => {
                this.orderInfo.document_uploads.push(data.msg);
            }, (error) => {
                console.log(error);
                this.showErrorUploadFile = true;
                this.uploadingFile = false;
            }, () => {
                this.uploadingFile = false;
            });

    }

    dropFile(ev) {
        ev.preventDefault();
        if (ev.dataTransfer && ev.dataTransfer.files && ev.dataTransfer.files.length > 0) {
            this.uploadFile(ev.dataTransfer.files[0]);
        }
    }

    fileChanged(ev) {
        ev.preventDefault();
        if (ev.target && ev.target.files && ev.target.files.length > 0) {
            this.uploadFile(ev.target.files[0]);
        }
    }

    allowDrop(ev) {
        ev.preventDefault();
    }

    ngOnDestroy() {
        if (this.allSubscription && this.allSubscription.length) {
            this.allSubscription.map(subs => subs.unsubscribe());
        }
    }
}
